import { render, staticRenderFns } from "./Fuente-baja.vue?vue&type=template&id=6162e6d8"
import script from "./Fuente-baja.vue?vue&type=script&lang=js"
export * from "./Fuente-baja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports